module.exports = __webpack_public_path__ + "img/icon-instagram.14478861.svg";